module.exports = __webpack_public_path__ + "static/img/cart.423c366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cart.jpg
// module id = F+XV
// module chunks = 31